import { z } from "zod";
export const zClientVehicleDom = z.object({
    id: z.string(),
    clientId: z.string(),
    brand: z.string().nullable(),
    model: z.string().nullable(),
    stateNumber: z.string().nullable(),
    color: z.string().nullable(),
    isActive: z.boolean(),
});
/** «Tesla Model 3, А777АА777» / «Автомобиль без названия». */
export const clientVehicleLabel = (vehicle) => {
    const name = [vehicle.brand, vehicle.model].filter(Boolean).join(" ");
    const base = name || "Автомобиль";
    return vehicle.stateNumber ? `${base}, ${vehicle.stateNumber}` : base;
};
